import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class RelatoriosService {
    private urlModulo = `${environment.urlAPI}/relatorios`;

    constructor(private http: HttpClient) { }

    /**
     * Retorna uma lista com a quantidade de solicitação por tipo e data
     */
    public getQtdTipoSolicitacao(anoInicio: number, anoFim: number, mesInicio: string, mesFim: string, tipoAgrupamento: string): Promise<any> {
        let params = new HttpParams()
            .set('anoInicio', anoInicio.toString())
            .append('anoFim', anoFim.toString())
            .append('mesInicio', mesInicio)
            .append('mesFim', mesFim)
            .append('tipoAgrupamento', tipoAgrupamento);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-tiposolicitacao`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Retorna uma lista com a quantidade de auditorias por tipo e data
     */
    public getQtdTipoAuditorias(anoInicio: number, anoFim: number, mesInicio: string, mesFim: string, tipoAgrupamento: string): Promise<any> {
        let params = new HttpParams()
            .set('anoInicio', anoInicio.toString())
            .append('anoFim', anoFim.toString())
            .append('mesInicio', mesInicio)
            .append('mesFim', mesFim)
            .append('tipoAgrupamento', tipoAgrupamento);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-qtdauditoriasagrupado`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Retorna o resultado das pesquisas de satisfação
     */
    public getQtdPesquisaSatisfacao(ano: number, mes: string): Promise<any> {
        let params = new HttpParams()
            .set('ano', ano.toString())
            .append('mes', mes);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-qtdpesquisasatisfacao`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Retorna relatório de pendências
     */
    public getRelatorioPendencias(filtro: any): Promise<any> {
        const params = new HttpParams().set('filtro', filtro);

        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-relatorioPendencias`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/relatorios.service.ts